import React from "react";
// import Carousel from '../carousel/carousel';
import { userDetailStore } from "../../config/store";
import { onSocialShareCT, postData } from "../../utils/helper";
import { imgUrl, imgBaseUrl, detailsPageBaseUrl } from "../../utils/url";
import $ from "jquery";
import Mantra6_3 from "../Mantra6/mantra6_3";
import DownloadBtnCommon from "../common/DownloadBtn";
import HomeIcon from "../common/HomeIcon";
import Loader from "../loader/loader";
import SharePrintIcon from "../common/SharePrintIcon";

class Mantra33_6 extends React.Component {
    constructor() {
        super();
        this.state = {
            body: "body body",
            subject: "subject",
            defaultemail:
                userDetailStore.getState().userDetail &&
                userDetailStore.getState().userDetail["user_email"],
            showThankYouPopUp: false,
            sendEmail: "",
            isLoading: false
        };
    }


    sendEmail = () => {

        this.setState({
            isLoading: true
        })

        const { pageData, module_name } = this.props;
        let text = pageData.description ? pageData.description : "";
        let title = pageData.name ? pageData.name : "";
        title = pageData.inner_name ? pageData.inner_name : title;
        let template_url = pageData.template_url

        let detailurl = detailsPageBaseUrl;
        if (module_name) {
            detailurl += module_name;
        }

        var params = {};

        // console.log(this.props);
        // return
        if (this.emailvalidate()) {
            params["email"] = this.email.value;
            // params["useremail"] = this.email.value;
            // params["file"] = imgBaseUrl + template_url;
            // params["body"] = text;
            // params["subject"] = title;
            // params["module_type"] = this.props.type; //module_type
            params["module_subtype"] = this.props.module_name; //sub module
            // params["message"] = text;

            postData(params, "sendmail").done((data) => {
                // swal("Email has been sent to:  " + this.email.value + " Thank you.");
                // postData(params, 'savedata', 'noloader');
                // this.email.value = "";
                if (data._resultflag === "1") {
                    this.setState(
                        { showThankYouPopUp: true, isLoading: false, sendEmail: this.email.value },
                        () => {
                            // this.email.value = "";
                            onSocialShareCT({
                                type: "mail",
                                shareurl: detailurl,
                                text: text,
                                module: module_name ? module_name : ""
                            });
                        }
                    );
                } else {
                    this.setState({
                        isLoading: false
                    })
                }
            });
        }
    };
    emailvalidate = () => {
        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (filter.test(this.email.value)) {
            var email = this.email.value;
            $(".send_email_button").find("img").removeClass("disabled");
            return true;
        } else {
            $(".send_email_button").find("img").addClass("disabled");
            //swal( "Invalid Email !" );
            return false;
        }
    };

    closeThankYouPopUp = () => {
        this.setState({
            showThankYouPopUp: false,
            sendEmail: "",
        });
    };

    render() {
        const {
            defaultemail,
            body,
            subject,
            showThankYouPopUp,
            sendEmail,
            isLoading
        } = this.state;
        const { pageData, module_name } = this.props;
        let image = pageData.template_url ? imgUrl + pageData.template_url : "";
        let text = pageData.description ? pageData.description : "";

        return (
            <div>
                {/* <Carousel /> */}

                {
                    isLoading && (
                        <Loader />
                    )
                }

                {showThankYouPopUp && (
                    <Mantra6_3
                        email={sendEmail}
                        closeThankYouPopUp={this.closeThankYouPopUp}
                    />
                )}

                {!showThankYouPopUp && (
                    <>
                        <HomeIcon />
                        <div className="container">
                            <SharePrintIcon pageData={this.props.pageData} image={image} text={text} id={module_name} />
                                    
                            {/* <div className="mantra_sharelist mantra_sharelist_margin">
                                <ul>
                                    <li>
                                        <img
                                            src="/assets/img/share.png"
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </li>
                                    <li>
                                        <img
                                            src="/assets/img/print.png"
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </li>
                                </ul>
                            </div> */}
                            <div className="mantra33_bg_yellow">
                                <div className="mantra33_bg_white">
                                    <div className="mantra33_upload_div">
                                        <img
                                            src="/assets/img/userdefault.png"
                                            className="img-fluid d-block mx-auto user_img"
                                            alt=""
                                        />
                                        <img
                                            src="/assets/img/multistar.png"
                                            className="img-fluid multistar_img"
                                            alt=""
                                        />
                                        <img
                                            src="/assets/img/camera.png"
                                            className="img-fluid change_img"
                                            alt=""
                                        />
                                    </div>
                                    <div className="upload_heading">
                                        <h5>Upload your parent’s photo</h5>
                                    </div>

                                    <table className="table table-bordered table-responsive table_class">
                                        <thead>
                                            <tr>
                                                <th className="serail_bg">No</th>
                                                <th className="parameter_bg">PARAMETERS</th>
                                                <th className="rating_bg">RATING</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Openness</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star1">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star2">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star3">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star4">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star5">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star6">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star7">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star8">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star9">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star10">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Approachab</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>3</td>
                                                <td>Cool Quotient</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star1">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star2">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star3">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star4">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star5">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star6">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star7">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star8">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star9">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star10">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Patience</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>5</td>
                                                <td>Flexiblity</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star1">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star2">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star3">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star4">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star5">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star6">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star7">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star8">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star9">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star10">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>Humor</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>7</td>
                                                <td>Support</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star1">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star2">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star3">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star4">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star5">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star6">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star7">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star8">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star9">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star10">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Respect</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>9</td>
                                                <td>Loving</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star1">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star2">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star3">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star4">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star5">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star6">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star7">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star8">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star9">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star10">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>10</td>
                                                <td>Approachab</td>
                                                <td>
                                                    <ul className="star_rating">
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                        <li className="star">
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="total_score">
                                        <h6>
                                            TOTAL SCORE <span>19</span>/100
                    </h6>
                                    </div>

                                    <div className="preview_btn">
                                        <DownloadBtnCommon pageData={this.props.pageData} module={module_name}>
                                            <button type="button" className="share2_btn">
                                                Download
                      </button>
                                        </DownloadBtnCommon>
                                        <p className="preview_text">Or</p>
                                        <button
                                            type="button"
                                            className="email_btn_width"
                                            onClick={this.sendEmail}
                                        >
                                            Email
                    </button>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="email_div">
                        <p><label>Your email *</label></p>
                        <input type="text" placeholder="Email" />
                    </div> */}
                            <div className="email_div">
                                <p>
                                    <label>Your email *</label>
                                </p>
                                <input
                                    type="text"
                                    ref={(email) => {
                                        this.email = email;
                                    }}
                                    defaultValue={defaultemail}
                                    placeholder="Email"
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default Mantra33_6;
